import React, { useEffect, useState } from "react";
import {
  Dropdown,
  Form,
  Input,
  InputNumber,
  Popconfirm,
  Select,
  Spin,
  Table,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import TableLoading from "../../../../../components/TableLoading";
import svg29 from "../../../../../assets/svg/svg29.svg";
import { fetchData } from "../../../../../features/fetch/fetchSlice";
import { formatPath, previewPaper } from "../../../../../utils";
import uplooadSimple from "../../../../../assets/UploadSimple.svg";
import { saveFile } from "../../../../../features/save/saveSlice";
import { render } from "@testing-library/react";

const EditableCell = ({
  mngrCrops,
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  fileUrl,
  handleCancelFile,
  handleOpenFIle,
  handleUpload,
  ...restProps
}) => {
  const inputNode = (() => {
    if (inputType === "filepath") {
      return fileUrl ? (
        <div className="text-blueDark w-full flex justify-between items-center h-auto px-3 input truncate">
          <span className="text-[18px]">{formatPath(fileUrl)}</span>
          <button
            type="button"
            onClick={handleCancelFile}
            className="flex items-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M9.5 13H15.5C15.7652 13 16.0196 12.8946 16.2071 12.7071C16.3946 12.5196 16.5 12.2652 16.5 12C16.5 11.7348 16.3946 11.4804 16.2071 11.2929C16.0196 11.1054 15.7652 11 15.5 11H9.5C9.23478 11 8.98043 11.1054 8.79289 11.2929C8.60536 11.4804 8.5 11.7348 8.5 12C8.5 12.2652 8.60536 12.5196 8.79289 12.7071C8.98043 12.8946 9.23478 13 9.5 13ZM21.5 2H3.5C3.23478 2 2.98043 2.10536 2.79289 2.29289C2.60536 2.48043 2.5 2.73478 2.5 3V21C2.5 21.2652 2.60536 21.5196 2.79289 21.7071C2.98043 21.8946 3.23478 22 3.5 22H21.5C21.7652 22 22.0196 21.8946 22.2071 21.7071C22.3946 21.5196 22.5 21.2652 22.5 21V3C22.5 2.73478 22.3946 2.48043 22.2071 2.29289C22.0196 2.10536 21.7652 2 21.5 2ZM20.5 20H4.5V4H20.5V20Z"
                fill="#147CBC"
              />
            </svg>
          </button>
        </div>
      ) : (
        <div className="input relative" onClick={handleOpenFIle}>
          <input
            className="!hidden"
            accept=".pdf"
            id="file"
            name="file"
            onChange={handleUpload}
            type="file"
          />
          <div className="absolute inset-0 flex items-center justify-end pointer-events-none px-3">
            <img src={uplooadSimple} alt="uploadSimple" />
          </div>
        </div>
      );
    }

    if (inputType === "dropdown") {
      return (
        <Select
          suffixIcon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
            >
              <path
                d="M17.1922 8.21268L10.9422 14.4627C10.8841 14.5208 10.8152 14.5669 10.7393 14.5983C10.6634 14.6298 10.5821 14.646 10.5 14.646C10.4178 14.646 10.3365 14.6298 10.2606 14.5983C10.1848 14.5669 10.1158 14.5208 10.0578 14.4627L3.80779 8.21268C3.69052 8.0954 3.62463 7.93634 3.62463 7.77049C3.62463 7.60464 3.69052 7.44558 3.80779 7.3283C3.92507 7.21103 4.08413 7.14514 4.24998 7.14514C4.41583 7.14514 4.57489 7.21103 4.69217 7.3283L10.5 13.1369L16.3078 7.3283C16.3659 7.27023 16.4348 7.22417 16.5107 7.19274C16.5865 7.16132 16.6679 7.14514 16.75 7.14514C16.8321 7.14514 16.9134 7.16132 16.9893 7.19274C17.0652 7.22417 17.1341 7.27023 17.1922 7.3283C17.2502 7.38637 17.2963 7.45531 17.3277 7.53118C17.3592 7.60705 17.3753 7.68837 17.3753 7.77049C17.3753 7.85261 17.3592 7.93393 17.3277 8.0098C17.2963 8.08567 17.2502 8.15461 17.1922 8.21268Z"
                fill="#212121"
              />
            </svg>
          }
          options={mngrCrops?.map((item, index) => ({
            label: (
              <div key={index}>
                <span>{item?.cropName}</span>
              </div>
            ),
            value: item?.cropName,
          }))}
        />
      );
    }

    return (
      <InputNumber
        id="input-focus"
        className="input flex"
        variant="borderless"
      />
    );
  })();

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          className="table-form-item"
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `Field is required`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

export default function IwuaLicenseTable({ dataSource, setDataSource }) {
  const urlLicense = "sch/get_institution_licences";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[urlLicense] || [],
    count: state.fetch.count[urlLicense] || 0,
  }));
  const { mngrCrops } = useSelector((state) => state.fetch);
  const { saving } = useSelector((state) => state.save);
  const { activeObjSchemes } = useSelector((state) => ({
    activeObjSchemes: state.obj.activeObj["schemes"],
  }));
  const dispatch = useDispatch();
  const navigate = useNavigate;
  const [form] = Form.useForm();

  const [editingKey, setEditingKey] = useState("");
  const [selectedObj, setselectedObj] = useState({});

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  // const [dataSource, setDataSource] = useState(data);

  const handleAddRow = async () => {
    try {
      await form.validateFields();
      const newRow = {
        licId: null,
        licType: "",
        lcLicId: "",
        lcPath: "",
      };
      setDataSource([...dataSource, newRow]);
      edit(newRow);
    } catch (errInfo) {
      toast.error("Please fill all fields before adding a new row");
    }
  };

  const handleRemove = async () => {
    try {
      const updatedDataSource = dataSource.filter(
        (item) => !selectedRowKeys.includes(item.licId)
      );

      setDataSource(updatedDataSource);
      setSelectedRowKeys([]);
    } catch (error) {
      console.error("Error deleting:", error);
      toast.error("Failed to delete items");
    }
  };

  const onSelectChange = (keys, rows) => {
    setSelectedRowKeys(keys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const isEditing = (record) => record?.licId === editingKey;

  const edit = (record) => {
    form.setFieldsValue({
      ...record,
    });
    setEditingKey(record?.licId);
  };

  const cancel = () => {
    setEditingKey("");
  };

  const handleDelete = async () => { 
    const newData = [...dataSource];
    const index = newData?.findIndex(
      (item) => selectedObj?.licId === item?.licId
    );

    if (index > -1) {
      const item = newData[index];
      const updatedObj = {
        ...item,
        lcPath: null,
      }; 
      newData.splice(index, 1, updatedObj);
      setDataSource(newData);
    }
  };

  const onSaveBtn =  async(key)=>{
    await setEditingKey("");
    await setfileUrl("");
    await setEditingKey("");
    await setProdd()
  }

  const saveFunction = async (key,file) => { 
    try {
      const row = await form.validateFields();
      const newData = [...dataSource];
      const index = newData?.findIndex((item) => key === item?.licId); 
      if (index > -1) {
        const item = newData[index];
        const updatedObj = {
          ...item,
          ...row,
          lcPath: file,
          // lcPath: fileUrl,
        }; 
        newData.splice(index, 1, updatedObj);

        setDataSource(newData);
        setEditingKey("");
        setfileUrl("");
        await setEditingKey("");
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  const items = [
    {
      key: "1",
      label: (
        <div onClick={() => edit(selectedObj)} className="pointer w-full">
          Edit
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <Popconfirm
          okText="Confirm"
          cancelText="Cancel"
          cancelButtonProps={{
            style: {
              background: "#D3D3D9",
              color: "#212143",
              fontWeight: 500,
              fontSize: ".875rem",
              borderRadius: "0.375rem",
              padding: ".5rem",
              width: "fit-content",
              height: "2.0625rem",
              marginRight: 10,
            },
          }}
          okButtonProps={{
            style: {
              background: "#212121",
              color: "#fff",
              fontWeight: 500,
              fontSize: ".875rem",
              borderRadius: "0.375rem",
              padding: ".5rem",
              width: "fit-content",
              height: "2.0625rem",
            },
          }}
          title={`Are you sure to you want to remove" ${selectedObj?.licType}?`}
          onConfirm={handleDelete}
        >
          <div className="pointer w-full">Remove License</div>
        </Popconfirm>
      ),
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      width:'10px',
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "License",
      dataIndex: "licType",
      editable: true,
      width: 200,
    },
    {
      title: "Upload",
      dataIndex: "lcPath",
      render: (item) => {
        return (
          <div
            className="cursor-pointer underline text-darkBlue"
            onClick={() => previewPaper(item)}
          >
            {formatPath(item)}
          </div>
        );
      },
      editable: true,
    },

    {
      title: "Action",
      dataIndex: "operation",
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <div className="flex w-fit items-center gap-[1rem]">
            <button onClick={cancel} className="modal_btn_light" type="button">
              Cancel
            </button>
            <button
              disabled={saving}
              type="button"
              onClick={() => onSaveBtn()}
              className="modal_btn_dark"
            >
              {saving ? <Spin /> : "Save"}
            </button>
          </div>
        ) : (
          <Dropdown
            overlayStyle={{
              width: "11.8125rem",
              margin: ".5rem",
              boxShadow: " 0px 1px 12px 0px rgba(25, 27, 35, 0.10)",
            }}
            overlayClassName="avatar_dropdown"
            arrow
            menu={{
              items: items,
            }}
            onOpenChange={(open) => {
              if (open) { 
                setselectedObj(record);
                setProdd(record)
              } else {
                setselectedObj({});
              }
            }}
            trigger={["click"]}
            placement="bottom"
          >
            <button type="button">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <path
                  d="M16 17.5C16.8284 17.5 17.5 16.8284 17.5 16C17.5 15.1716 16.8284 14.5 16 14.5C15.1716 14.5 14.5 15.1716 14.5 16C14.5 16.8284 15.1716 17.5 16 17.5Z"
                  fill="#343330"
                />
                <path
                  d="M24.5 17.5C25.3284 17.5 26 16.8284 26 16C26 15.1716 25.3284 14.5 24.5 14.5C23.6716 14.5 23 15.1716 23 16C23 16.8284 23.6716 17.5 24.5 17.5Z"
                  fill="#343330"
                />
                <path
                  d="M7.5 17.5C8.32843 17.5 9 16.8284 9 16C9 15.1716 8.32843 14.5 7.5 14.5C6.67157 14.5 6 15.1716 6 16C6 16.8284 6.67157 17.5 7.5 17.5Z"
                  fill="#343330"
                />
              </svg>
            </button>
          </Dropdown>
        );
      },
    },
  ];

  const [fileUrl, setfileUrl] = useState(""); 
  const [prodd,setProdd]=  useState()  
  async function handleUpload(e) { 
    const formObject = new FormData();
    formObject.append("file", e.target.files[0]);
    const file = e.target.files[0];
    if (file) {
      const maxSize = 10 * 1024 * 1024;
      if (file.size > maxSize) {
        toast.error("File size exceeds 10MB. Please upload a smaller file.");
        return;
      }
      const res = await dispatch(saveFile(formObject));

      if (res?.payload?.success) {
        await setfileUrl(res.payload?.targetUrl);
        await toast.success(res?.payload?.message); 
         if (prodd?.licId) { 
        await saveFunction(prodd.licId,res.payload?.targetUrl);  
      } else {
        console.log("prodd.licId is missing");
      }
        
      } else {
        toast.error(res?.payload?.message);
      }
    }
  }

  async function handleOpenFIle() {
    document.getElementById("file").click();
  }
  async function handleCancelFile() {
    await setfileUrl();
  }

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        dataIndex: col.dataIndex,
        inputType:
          col.dataIndex === "prodCrops"
            ? "dropdown"
            : col.dataIndex === "lcPath"
            ? "filepath"
            : "text",
        title: col.title,
        editing: isEditing(record),
        mngrCrops: mngrCrops,
        fileUrl: fileUrl,
        handleCancelFile: handleCancelFile,
        handleOpenFIle: handleOpenFIle,
        handleUpload: handleUpload,
      }),
    };
  });

  // useEffect(() => {
  //   handleFetch();
  // }, []);

  // useEffect(() => {
  //   setDataSource(data);
  // }, [data]);

  return (
    <>
      <div className="grid grid-cols-1 gap-[1.25rem] flex-1">
        <div className=" flex-col">
          {loading ? (
            <TableLoading />
          ) : (
            <Form form={form} component={false}>
              <Table
                rowSelection={rowSelection}
                className="mt-[1.25rem]"
                components={{
                  body: {
                    cell: EditableCell,
                  },
                }}
                rowKey={(record) => record?.licId}
                dataSource={dataSource}
                columns={mergedColumns}
                scroll={{
                  x: 700,
                }}
                footer={() => {
                  return (
                    <>
                      <div className="flex items-center w-full justify-between gap-[1.25rem] p-[1rem]">
                        {
                          selectedRowKeys.length > 0 ? (
                            <button
                              type="button"
                              onClick={handleRemove}
                              className="flex items-center gap-[.5rem]"
                            >
                              <div className="black-round-btn !bg-[#fff] !border !border-[#C72C3B]">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M20.25 4.5H16.5V3.75C16.5 3.15326 16.2629 2.58097 15.841 2.15901C15.419 1.73705 14.8467 1.5 14.25 1.5H9.75C9.15326 1.5 8.58097 1.73705 8.15901 2.15901C7.73705 2.58097 7.5 3.15326 7.5 3.75V4.5H3.75C3.55109 4.5 3.36032 4.57902 3.21967 4.71967C3.07902 4.86032 3 5.05109 3 5.25C3 5.44891 3.07902 5.63968 3.21967 5.78033C3.36032 5.92098 3.55109 6 3.75 6H4.5V19.5C4.5 19.8978 4.65804 20.2794 4.93934 20.5607C5.22064 20.842 5.60218 21 6 21H18C18.3978 21 18.7794 20.842 19.0607 20.5607C19.342 20.2794 19.5 19.8978 19.5 19.5V6H20.25C20.4489 6 20.6397 5.92098 20.7803 5.78033C20.921 5.63968 21 5.44891 21 5.25C21 5.05109 20.921 4.86032 20.7803 4.71967C20.6397 4.57902 20.4489 4.5 20.25 4.5ZM9 3.75C9 3.55109 9.07902 3.36032 9.21967 3.21967C9.36032 3.07902 9.55109 3 9.75 3H14.25C14.4489 3 14.6397 3.07902 14.7803 3.21967C14.921 3.36032 15 3.55109 15 3.75V4.5H9V3.75ZM18 19.5H6V6H18V19.5ZM10.5 9.75V15.75C10.5 15.9489 10.421 16.1397 10.2803 16.2803C10.1397 16.421 9.94891 16.5 9.75 16.5C9.55109 16.5 9.36032 16.421 9.21967 16.2803C9.07902 16.1397 9 15.9489 9 15.75V9.75C9 9.55109 9.07902 9.36032 9.21967 9.21967C9.36032 9.07902 9.55109 9 9.75 9C9.94891 9 10.1397 9.07902 10.2803 9.21967C10.421 9.36032 10.5 9.55109 10.5 9.75ZM15 9.75V15.75C15 15.9489 14.921 16.1397 14.7803 16.2803C14.6397 16.421 14.4489 16.5 14.25 16.5C14.0511 16.5 13.8603 16.421 13.7197 16.2803C13.579 16.1397 13.5 15.9489 13.5 15.75V9.75C13.5 9.55109 13.579 9.36032 13.7197 9.21967C13.8603 9.07902 14.0511 9 14.25 9C14.4489 9 14.6397 9.07902 14.7803 9.21967C14.921 9.36032 15 9.55109 15 9.75Z"
                                    fill="#C72C3B"
                                  />
                                </svg>
                              </div>

                              <span className="role_btn_text !text-[#C72C3B]">
                                Remove selected
                              </span>
                            </button>
                          ) : null
                          // <button
                          //   type="button"
                          //   onClick={handleAddRow}
                          //   className="cstm-btn-2 !w-[120px]"
                          // >
                          //   <img src={svg29} alt="svg29" />
                          //   <span className="">Add License</span>
                          // </button>
                        }
                      </div>
                    </>
                  );
                }}
              />
            </Form>
          )}
        </div>
      </div>
    </>
  );
}
